import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Loading from "../common/Loading"
const AnonymousRoutes = ({ isLoggedIn }) => {
  return isLoggedIn ? (
    <Navigate to="/" replace />
  ) : (
    <Suspense
      fallback={
        <div className="loader-container">
          <div className="loader-container-inner">
            <div className="text-center">
              <Loading />
            </div>
          </div>
        </div>
      }
    >
      <Outlet />
    </Suspense>
  );
};

export default AnonymousRoutes;
